import { render } from "./CreateWarehouseModal.vue?vue&type=template&id=aa32f13c&scoped=true&ts=true"
import script from "./CreateWarehouseModal.vue?vue&type=script&lang=ts"
export * from "./CreateWarehouseModal.vue?vue&type=script&lang=ts"

import "./CreateWarehouseModal.vue?vue&type=style&index=0&id=aa32f13c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa32f13c"]])

export default __exports__